
import { Component, Injector, Input, OnInit } from '@angular/core';
import {
    ComponentContextService, DataFormBase, EventData, FormSchemaBase, TextControlSchema,
    SwitchControlSchema, DateTimeControlSchema
} from 'tnx-shared';
import { ExtensionAttributeService } from 'tnx-admin-service/workflowcore/extensionattribute/services';

@Component({
    selector: 'extensionattribute-form',
    templateUrl: './extensionattribute-form.component.html',
    styleUrls: ['./extensionattribute-form.component.scss'],
    providers: [ComponentContextService],
})
export class ExtensionAttributeFormComponent extends DataFormBase implements OnInit {

    constructor(
        protected _injector: Injector,
        private _extensionAttributeService: ExtensionAttributeService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._extensionAttributeService;
        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'persistenceId',
                label: ''
            }),
            new TextControlSchema({
                field: 'attributeKey',
                label: ''
            }),
            new TextControlSchema({
                field: 'attributeValue',
                label: ''
            }),
            new TextControlSchema({
                field: 'executionPointerId',
                label: ''
            }),
            new TextControlSchema({
                field: 'currentStateCode',
                label: ''
            }),
            new TextControlSchema({
                field: 'code',
                label: ''
            })
        ];
    }

    async onFormInitialized(formEvent: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
    }

    async onFormEvent(evt) {
        // các event trong form
        console.log(evt);
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
    }

    async onAfterGetDetail() {
        // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    }

    onBeforeSave() {
        // trước khi lưu
    }
}

